import NameStep from './NameStep.vue';
import PhoneStep from './PhoneStep.vue';
import EmailStep from './EmailStep.vue';
import PurposeStep from './PurposeStep.vue';
import FirstHomeStep from './FirstHomeStep.vue';
import RefinancingReason from './RefinancingReason.vue';
import OccupancyTypeStep from './OccupancyTypeStep.vue';
import PropertyTypeStep from './PropertyTypeStep.vue';
import RealtorStep from './RealtorStep.vue';
import PurchasePriceStep from './PurchasePriceStep.vue';
import DownPaymentStep from './DownPaymentStep.vue';
import MonthlyPaymentStep from './MonthlyPaymentStep.vue';
import PrefferedTermStep from './PrefferedTermStep.vue';
import VeteranStep from './VeteranStep.vue';
import CreditScoreStep from './CreditScoreStep.vue';
import SelfEmployedStep from './SelfEmployedStep.vue';
import HouseholdIncomeStep from './HouseholdIncomeStep.vue';
import FSBStep from './FSBStep.vue';
import TimelineStep from './TimelineStep.vue';
import QuestionnaireIntro from './QuestionnaireIntro.vue'
import PropertyContractStep from './PropertyContractStep.vue';
import PropertyAddressStep from './PropertyAddressStep.vue';
import CurrentJobOrRole from './CurrentJobOrRole.vue';

export default {
  NameStep,
  PhoneStep,
  EmailStep,
  PurposeStep,
  FirstHomeStep,
  RefinancingReason,
  OccupancyTypeStep,
  PropertyTypeStep,
  RealtorStep,
  PurchasePriceStep,
  DownPaymentStep,
  MonthlyPaymentStep,
  PrefferedTermStep,
  VeteranStep,
  CreditScoreStep,
  SelfEmployedStep,
  HouseholdIncomeStep,
  FSBStep,
  TimelineStep,
  QuestionnaireIntro,
  PropertyContractStep,
  PropertyAddressStep,
  CurrentJobOrRole
};
